module.exports = __webpack_public_path__ + "static/media/uow.bb6baa52.png";